import styles from './ValueProps.module.css';

const PROPS = [
  {
    ix: '01 / Partnership',
    title: 'True Partnership',
    desc: 'I work alongside your team, not above it. Your success is my success.',
    glyph: (
      <svg className={styles.glyph} viewBox="0 0 24 24" fill="none" stroke="var(--coral)" strokeWidth="1.6">
        <path d="M16 11a4 4 0 1 0-8 0M12 11v9M5 20h14" />
      </svg>
    ),
  },
  {
    ix: '02 / Business-First',
    title: 'Business-First Approach',
    desc: 'I start with your goals, then figure out the technology — not the other way around.',
    glyph: (
      <svg className={styles.glyph} viewBox="0 0 24 24" fill="none" stroke="var(--coral)" strokeWidth="1.6">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
    ),
  },
  {
    ix: '03 / Practical',
    title: 'Practical Solutions',
    desc: 'No over-engineering. I build what you need, when you need it.',
    glyph: (
      <svg className={styles.glyph} viewBox="0 0 24 24" fill="none" stroke="var(--coral)" strokeWidth="1.6">
        <path d="M5 12l4 4L19 6" />
      </svg>
    ),
  },
];

export default function ValueProps() {
  return (
    <section className="section" id="approach">
      <div className="wrap">
        <div className="reveal">
          <span className="eyebrow">How I work</span>
          <h2 className="section-title" style={{ marginTop: 16 }}>
            Senior-level partnership,
            <br />
            without the agency overhead.
          </h2>
        </div>
        <div className={styles.vpGrid}>
          {PROPS.map((p) => (
            <div className={`${styles.vpCard} reveal`} key={p.ix}>
              <span className={styles.ix}>{p.ix}</span>
              {p.glyph}
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
